import {
  ADDUPDATE_BP_FAILED,
  ADDUPDATE_BP_INVALID_REQUEST,
  ADDUPDATE_BP_SUCCESS,
  LOADING_ADDUPDATE_BP,
  RESET_ADDUPDATE_BP,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  data: {},
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADDUPDATE_BP:
      return {
        ...state,
        isLoading: true,
        success: false,
        invalidRequest: false,
        failed: false,
        status: "",
      };

    case ADDUPDATE_BP_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        status: "Add/Update Business Person Failed !",
      };

    case ADDUPDATE_BP_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        invalidRequest: true,
        failed: false,
        success: false,
        status: "Oops!, Something went wrong",
      };

    case ADDUPDATE_BP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        failed: false,
        success: true,
        data: action.payload,
        status: "Add/Update Business Person Success !",
      };

    case RESET_ADDUPDATE_BP:
      return (state = initialState);

    default:
      return state;
  }
};
